import appConfig from '../config/appConfig';
import * as iccSsoDeeplinkTemplates from '../consts/icc/iccSsoDeeplinkTemplates';
import * as logMessageTypes from '../consts/log/logMessageTypes';
import backendService from './app/backendService';
import authDataStoreService from './auth/authDataStoreService';
import * as gigyaService from './gigya/gigyaService';
import iccMarketService from './icc/iccMarketService';
import iccSsoService from './icc/iccSsoService';
import log from './logger/log';
import dcsService from './market/dcs/dcsService';
import marketTypeService from './marketTypeService';
import appRouterService from './route/appRouterService';
import routerService from './routerService';
import storageService from './storage/storageService';

const CONSUMER_HAV_CONFIRMED = 'YES';
const CONSUMER_HAV_DECLINED = 'NO';

const verifyHav = async () => {
    const isGamBackend = backendService.isGamBackend();

    if (isGamBackend) return;

    const isDCE2 = marketTypeService.isDCE2();
    const gigyaToken = gigyaService.getGigyaToken();
    const spiceToken = authDataStoreService.getSpiceToken();

    if (!spiceToken && !gigyaToken) return;

    const isHAVMandatory = appConfig.getIsHAVMandatory();

    if (!isHAVMandatory) {
        await iccMarketService.getConsumerProfile();
        return true;
    }

    if (isDCE2) return;

    const consumerData = await iccMarketService.getExternalConsumerProfile();

    if (!consumerData) {
        appRouterService.forwardToAgeVerificationFailedPage();

        return false;
    }

    const hav = consumerData.hav;
    const isMarketHAVAvailable = appConfig.getIsMarketHAVAvailable();

    switch (hav?.toUpperCase()) {
        case CONSUMER_HAV_CONFIRMED:
            //TODO: action when hav confirmed
            return true;
        case CONSUMER_HAV_DECLINED:
            if (isMarketHAVAvailable) {
                const iqosHomeUrl = appConfig.getIqosHomeUrlFormatted();

                routerService.redirect(iqosHomeUrl);

                return false;
            } else {
                appRouterService.forwardToAgeVerificationFailedPage();

                return false;
            }
        default:
            try {
                const ssoLink = await iccSsoService.getSsoLink(iccSsoDeeplinkTemplates.ICC_SSO_HAV_DEEPLINK_TEMPLATE);

                if (ssoLink?.errorStatus) {
                    appRouterService.forwardToIccErrorHandlingPage(ssoLink.errorStatus);
                    return;
                }

                if (ssoLink) {
                    storageService.removeUserSessionDataFromStorage();
                    routerService.redirect(ssoLink);

                    return false;
                } else {
                    if (isMarketHAVAvailable) {
                        dcsService.showHAV();

                        return false;
                    } else {
                        appRouterService.forwardToAgeVerificationFailedPage();

                        return false;
                    }
                }
            } catch (e) {
                log.error(`havService: showHAV, error: ${e}`, {logMessageType: logMessageTypes.ICC});
            }
            break;
    }
};

export default {
    verifyHav,
};
